module.exports = __webpack_public_path__ + "static/media/sleepIconSemSobra.c979403c.svg";